var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolisIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:url(#c);}.e{fill:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 16.3555,
    y1: 28.2038,
    x2: 15.6828,
    y2: 9.0172,
    gradientTransform: "translate(0 34) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#ffc40c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2612b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 16.3554,
    y1: 28.2038,
    x2: 15.6827,
    y2: 9.0172,
    xlinkHref: "#b"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M14.1151,16.4115c-2.741,0-5.4517.2015-8.0695.5984.5068,5.0484,4.7692,8.9901,9.9521,8.9901s9.0455-3.5823,9.8569-8.2908c-3.7175-.8611-7.6613-1.2977-11.7395-1.2977Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M14.1152,15.1026c4.1196,0,8.1087.4356,11.8772,1.2949.0051-.1322.0078-.2643.0078-.3975-.0005-5.5231-4.4785-10-10.0025-10S6.1616,10.3123,5.9997,15.6932c2.6363-.3919,5.361-.5907,8.1155-.5907Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolisIcon);
export default __webpack_public_path__ + "static/media/solis-icon.09a2b666e8d0d8f53d25f674f975987c.svg";
export { ForwardRef as ReactComponent };